// UI-SPEC §"Component Inventory" §Toast (Sonner) — default (foreground), success (CircleCheck
// icon), destructive (destructive bg + CircleAlert). Auto-dismiss 4s except destructive (manual).
//
// ÂNCORA (OS 18228 · D-01..D-04, D-14, D-16) — TRÊS regimes, um único ponto de definição:
//   ≥768px   `bottom-left` — fora do FAB do WhatsApp, que mora no canto inferior direito.
//   601–767  `useIsMobile()` já diz "mobile", mas o sonner só vira full-width em 600px e ainda lê
//            `--offset-top`: quem segura o toast abaixo do Header nesta faixa é o `offset`.
//   ≤600px   toast full-width, lendo `--mobile-offset-top`.
// Os DOIS offsets carregam a MESMA fórmula de propósito — apagar um deles descobre uma faixa:
// sem o `offset`, 601–767px volta a cobrir o Header (11.392 px² medidos na pesquisa da fase).
'use client';

import type { ComponentProps } from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';
import { useIsMobile } from '@/shared/ui/responsive/use-is-mobile';

type ToasterProps = ComponentProps<typeof SonnerToaster>;

export function Toaster({ ...props }: ToasterProps) {
  // `getServerSnapshot()` devolve `false` (desktop) no servidor e no primeiro paint; a correção
  // para mobile chega pós-hidratação, sem mismatch de SSR (molde: ChatFab.tsx:45-52).
  const isMobile = useIsMobile();
  return (
    <SonnerToaster
      duration={4000}
      toastOptions={{
        classNames: {
          // Sober monochrome treatment per UI-SPEC §Color.
          toast:
            'group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-sm group-[.toaster]:rounded-md',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-foreground',
          error:
            'group-[.toaster]:bg-destructive group-[.toaster]:text-destructive-foreground group-[.toaster]:border-destructive',
          success: 'group-[.toaster]:bg-card group-[.toaster]:text-foreground',
        },
      }}
      {...props}
      // D-14: DEPOIS do spread de propósito — nenhuma das 75 telas que montam este wrapper
      // consegue sobrescrever a âncora; o guard de D-12 vira segunda linha de defesa.
      position={isMobile ? 'top-center' : 'bottom-left'}
      offset={{ top: 'calc(3.5rem + env(safe-area-inset-top, 0px) + 0.5rem)' }}
      mobileOffset={{ top: 'calc(3.5rem + env(safe-area-inset-top, 0px) + 0.5rem)' }}
    />
  );
}

export { toast };
